<template>
  <WarrantsDataTableTab
    :headers="headers"
    error-title="Failed to load jobs"
    data-testid="warrants-files-jobs"
    searchable
    search-placeholder="Search job ID"
    :fetcher="fetchJobs"
    :items-from="itemsFrom"
  >
    <template #[`item.status`]="{ internalItem }">
      <SoChip
        :type="filesJobStatusChipType(internalItem.raw.status)"
        :text="internalItem.raw.statusDisplay"
        size="small"
      />
    </template>
  </WarrantsDataTableTab>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoChip from "@/components/SoChip.vue"
  import WarrantsDataTableTab from "@/views/admin/warrants/components/WarrantsDataTableTab.vue"
  import { SoDataTableOptions } from "@/components/dataTable/SoDataTableServer.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
  } from "@/types/components/SoDataTable"
  import {
    idColumn,
    statusColumn,
  } from "@/views/admin/warrants/warrantsColumns"
  import {
    WarrantsFilesJobListResult,
    WarrantsFilesJobService,
  } from "@/services/admin/WarrantsFilesJobService"
  import { filesJobStatusChipType } from "@/views/admin/warrants/warrantStatusChip"

  const headers: SoDataTableHeader[] = [
    idColumn,
    statusColumn,
    {
      title: "Started At",
      key: "startedAt",
      type: SoDataTableColumnType.DATE_TIME,
      sortable: true,
      sortKey: "started_at",
      fallbackValue: "—",
    },
    {
      title: "Ended At",
      key: "endedAt",
      type: SoDataTableColumnType.DATE_TIME,
      sortable: true,
      sortKey: "ended_at",
      fallbackValue: "—",
    },
    {
      title: "Error Message",
      key: "errorMessage",
      sortable: false,
      fallbackValue: "—",
    },
  ]

  export default defineComponent({
    components: {
      SoChip,
      WarrantsDataTableTab,
    },
    data() {
      return {
        headers,
      }
    },
    methods: {
      filesJobStatusChipType,
      fetchJobs({ search, page, pageSize, orderBy }: SoDataTableOptions) {
        return WarrantsFilesJobService.getJobs(search, page, pageSize, orderBy)
      },
      itemsFrom(result: WarrantsFilesJobListResult) {
        return result.jobs
      },
    },
  })
</script>
